<p>
	Er zijn geen LETSgroepen voor elke stad/gemeente apart. <br>
Wij hebben liever een ruime vraag en aanbod, je kiest toch zelf hoe ver je wil gaan om te LETSen. ;-) <br>
&rarr; Je vindt de letsgroepen ook op <a target="_blank" href="https://www.letsvlaanderen.be/lets-groepen#">www.letsvlaanderen.be</a> bij &apos;groepen&apos;.
</p>

<img id="kaart" src="./images/kaart.jpg" alt="kaart" />
<style scoped>
	#kaart {
		width: 100%;
		height: 100%;
	}
</style>